<template>
  <div class="item">
    <div data-holder="time">{{ bus.time | cz_datetime }}</div>
    <div data-holder="capacity">{{ bus.usedByOther - (- bus.usedByMe) }}/{{ bus.capacity }}</div>
    <div data-holder="using">
      <input
        type="number"
        :value="bus.usedByMe"
        min="0"
        :max="max"
        @input="changed"
        @change="changed"
      />
      <button class="increase" @click="increase">
        <i class="fa fa-angle-up"></i>
      </button>
      <button class="decrease" @click="decrease">
        <i class="fa fa-angle-down"></i>
      </button>
      <button class="fill" @click="fill">
        <i class="fa fa-angle-double-up"></i>
      </button>
      <button class="empty" @click="empty">
        <i class="fa fa-angle-double-down"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "bus_item",
  props: ["bus", "not_fulfilled"],
  computed: {
    available() {
      return this.bus.capacity - this.bus.usedByMe - this.bus.usedByOther;
    },
    max() {
      return (
        (this.not_fulfilled > this.available
          ? this.available
          : this.not_fulfilled) - -this.bus.usedByMe
      );
    }
  },
  methods: {
    changed(event) {
      let value = parseInt(event.target.value);
      if (value > this.max) value = this.max;
      else if (value < 0) value = 0;

      this.update(value);
    },
    increase() {
      if (this.bus.usedByMe < this.max) {
        this.update(1 + this.bus.usedByMe);
      }
    },
    decrease() {
      if (this.bus.usedByMe > 0) {
        this.update(this.bus.usedByMe - 1);
      }
    },
    fill() {
      this.update(this.max);
    },
    empty() {
      this.update(0);
    },
    update(value) {
      this.$store.commit("update", {
        paths: ["buses", this.bus.direction, this.bus.id, "usedByMe"],
        value
      });
    }
  }
};
</script>
